import ClassMeetingIcon from './component.jsx'
export default ClassMeetingIcon
